import { Route } from '../enum/route.enum';

export const PING_INTERVAL = 5000;

export const COUNTDOWN_TIMEOUT = 60 * 60; // minutes * seconds
export const COUNTDOWN_STORAGE_KEY = 'pdr_countdown_remaining';
export const COUNTDOWN_STORAGE_TIMESTAMP_KEY = 'pdr_countdown_timestamp';
export const COUNTDOWN_STORAGE_PAUSED_KEY = 'pdr_countdown_paused';

export const CONTENT_PAGES = [Route.FAQS, Route.DATA_AND_AI_LEARNINGS, Route.IMPRINT];

export const LOCALE_STORAGE_LANGUAGE = 'app-language';

